import React from "react";

import { Box, Button, Link, Typography } from "@mui/material";

import { TEMPORAL_WORKFLOW_SAMPLES } from "../../../constants/temporal-workflow-samples";

interface LoadSamplePayloadButtonProps {
  workflowName: string;
  onLoad: (sampleJson: string) => void;
  disabled?: boolean;
}

const GITHUB_BASE =
  "https://github.com/SafetyCulture/temporal-workflows/blob/master/";

// Only renders once the typed workflow name exactly matches a known one --
// see constants/temporal-workflow-samples.ts for how these were extracted
// and its caveats (best-effort, may not match the actual wire format).
const LoadSamplePayloadButton = ({
  workflowName,
  onLoad,
  disabled,
}: LoadSamplePayloadButtonProps) => {
  const sample = TEMPORAL_WORKFLOW_SAMPLES[workflowName.trim()];
  if (!sample) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
        mt: 1,
        mb: 1.5,
      }}
    >
      <Button
        variant="outlined"
        size="small"
        disabled={disabled}
        onClick={() => onLoad(JSON.stringify(sample.sample, null, 2))}
        data-testid="load-sample-payload-button"
      >
        Load Sample Payload
      </Button>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ textAlign: "left" }}
      >
        From source (
        <Link
          href={`${GITHUB_BASE}${sample.sourceFile}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {sample.sourceType}
        </Link>
        ) — a best-effort reference, not a verified wire format. Review before
        executing.
      </Typography>
    </Box>
  );
};

export default LoadSamplePayloadButton;
